import React from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
export function Pricing() {
  return <section className="py-14 px-6 max-w-6xl mx-auto" id="pricing" data-id="element-209">
      <div className="text-center mb-8" data-id="element-210">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-211">
          ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
        </h2>
        <CountdownTimer data-id="element-212" />
        <p className="text-naranja font-bold text-lg mt-4 bg-naranja/10 inline-block px-6 py-2 rounded-full border border-naranja/20" data-id="element-213">
          ⚠️ Después sube $10.000 ARS. No vuelve.
        </p>
      </div>

      <h3 className="text-center text-2xl font-bold text-white mb-6" data-id="element-214">
        ELEGÍ TU MEGAPACK
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-stretch" data-id="element-215">
        {/* Card A */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-petroleo rounded-3xl p-8 border border-petroleoLight flex flex-col hover:-translate-y-1 transition-transform duration-300" data-id="element-216">
          <div className="text-4xl mb-4" data-id="element-217">📘</div>
          <h4 className="text-2xl font-bold text-white mb-2" data-id="element-218">
            MEGAPACK DOCENTE
          </h4>
          <p className="text-tealBrand font-medium mb-8" data-id="element-219">6 Tomos + 6 Bonos</p>

          <div className="mt-auto" data-id="element-220">
            <div className="mb-6" data-id="element-221">
              <div className="text-base text-gray-400 line-through font-medium mb-1" data-id="element-222">
                $89.000 ARS
              </div>
              <div className="flex items-baseline gap-2" data-id="element-223">
                <span className="text-4xl font-extrabold text-white tracking-tight" data-id="element-224">
                  $19.990
                </span>
                <span className="text-base text-gray-300 font-medium" data-id="element-225">ARS</span>
              </div>
            </div>
            <a id="cta-megapack" href="https://www.bibliotecasdigitales.store/checkouts/cn/hWNC3E2Ac5Ul1LShxH6jwS2M/es-ar?_r=AQABdYqjLg5UUZFA4jNsRAT5afNnhJQ5SjWUn7cGz-dSVq0&cart_link_id=LqRVGwQM&preview_theme_id=154708803747" target="_blank" rel="noopener noreferrer" className="group w-full flex flex-col items-center justify-center gap-0.5 bg-amarillo hover:bg-amarilloHover text-noche font-bold py-4 px-4 rounded-xl transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5" data-id="element-226">
              <span className="flex items-center gap-2 text-lg leading-tight" data-id="element-227">
                <span data-id="element-228">⚡</span>
                <span data-id="element-229">QUIERO MI MEGAPACK</span>
                <span data-id="element-230">📚</span>
              </span>
              <span className="text-xs font-semibold text-noche/70 tracking-wide uppercase" data-id="element-231">
                6 Tomos + 6 Bonos
              </span>
            </a>
          </div>
        </motion.div>

        {/* Card B - Featured */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="bg-petroleo rounded-3xl p-8 border-2 border-tealBrand relative flex flex-col shadow-[0_0_40px_rgba(20,184,166,0.15)] hover:-translate-y-1 transition-transform duration-300" data-id="element-232">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-tealBrand text-noche font-bold px-4 py-1 rounded-full text-sm tracking-wide" data-id="element-233">
            MÁS POPULAR
          </div>
          <div className="text-4xl mb-4" data-id="element-234">🏆</div>
          <h4 className="text-2xl font-bold text-white mb-2" data-id="element-235">
            MEGAPACK + CEREBRO DIGITAL ⭐
          </h4>
          <p className="text-tealBrand font-medium mb-4" data-id="element-236">
            6 Tomos + 6 Bonos + Sistema de Organización 360°
          </p>
          <p className="text-sm text-gray-300 mb-8" data-id="element-237">
            Notion + Drive + WhatsApp + Automatización de notas
          </p>

          <div className="mt-auto" data-id="element-238">
            <div className="mb-6" data-id="element-239">
              <div className="text-base text-gray-400 line-through font-medium mb-1" data-id="element-240">
                $119.000 ARS
              </div>
              <div className="flex items-baseline gap-2" data-id="element-241">
                <span className="text-4xl font-extrabold text-white tracking-tight" data-id="element-242">
                  $27.990
                </span>
                <span className="text-base text-gray-300 font-medium" data-id="element-243">ARS</span>
              </div>
            </div>
            <a href="https://www.bibliotecasdigitales.store/checkouts/cn/hWNC3ERKGkBLlKbBXeZgwHS6/es-ar?_r=AQABI4oUCQjYhRQVhqYGOzk2F25hFI0BRCcSYn5rxUsVdQc&cart_link_id=RKWwAu7G&preview_theme_id=154708803747" target="_blank" rel="noopener noreferrer" className="group w-full flex flex-col items-center justify-center gap-0.5 bg-amarillo hover:bg-amarilloHover text-noche font-bold py-4 px-4 rounded-xl transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5" data-id="element-244">
              <span className="flex items-center gap-2 text-lg leading-tight" data-id="element-245">
                <span data-id="element-246">⚡</span>
                <span data-id="element-247">LO QUIERO COMPLETO</span>
                <span data-id="element-248">📚</span>
              </span>
              <span className="text-xs font-semibold text-noche/70 tracking-wide uppercase" data-id="element-249">
                Megapack + Cerebro Digital
              </span>
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}